<template>
  <ListPanel mode="pending" :fetch-list="fetchPendingList" />
</template>

<script>
import ListPanel from "./components/list-panel.vue";
import { fetchPendingList } from "@/api/oa/workOrder";

export default {
  name: "workOrderPending",
  components: { ListPanel },
  data() {
    return {
      fetchPendingList,
    };
  },
};
</script>
